import { Exclude, Expose, Transform } from 'class-transformer';
import { IsArray, IsNumber, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';

export class SitemapBillingProductResponseDto extends BaseDto {
  @IsNumber()
  sitemapId: number;

  @IsNumber()
  billingProductId: number;

  @IsNumber()
  minimumSubscriptionId: number;

  @IsString()
  minimumSubscriptionName: string;

  @Transform((value) => value && value.split(',').map(Number), {
    toClassOnly: true
  })
  subscriptionIdList: number[];
}
